import React from 'react';
import { ExpertCertificateContainer } from '../../containers';

const ExpertCertificatePage = () => <ExpertCertificateContainer />;

export default ExpertCertificatePage;
